import { Box } from "@mui/material";
import Popper from "@mui/material/Popper";
import { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import ReactTooltip from "react-tooltip";

import { H3, Span, TableFilterIcon } from "@/Components";
import { VerticalCheckbox } from "@/Components/VerticalCheckbox/VerticalCheckbox";
import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { colors } from "@/Utils";

import { FilterBody, FilterHeader, FilterIconWrap } from "./Style";

const TableFilter = ({ columns = [], checkedState, handleFilterCheckbox }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const { theme } = useInfo();

  const handleOutsideClick = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
    setTooltipOpen(false);
  };

  const handleTooltip = (event) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setTooltipOpen(!tooltipOpen);
  };

  return (
    <>
      <FilterIconWrap>
        <ReactTooltip
          arrowColor="transparent"
          backgroundColor={theme.mode === "dark" ? colors.darkGray : colors.secondaryColor}
          place="bottom"
          id={`hover-filter`}
          type="dark"
          className="react-tooltip-custom"
        >
          <Span fSize={13} pdtop={5}>
            Filter and Sort
          </Span>
        </ReactTooltip>
        <TableFilterIcon onClick={handleTooltip} data-tip data-for={`hover-filter`} />
      </FilterIconWrap>
      <Popper
        sx={{ zIndex: 1000 }}
        open={tooltipOpen}
        placement={"right-start"}
        anchorEl={anchorEl}
        transition={false}
        // Prevents page css from breaking by not updating translate3d on Popper
        popperOptions={{
          modifiers: [
            {
              preventOverflow: {
                padding: 0,
              },
            },
          ],
        }}
      >
        <OutsideClickHandler onOutsideClick={handleOutsideClick}>
          <Box
            sx={{
              position: "absolute",
              right: "1px",
              top: "-1px",
              width: "220px",
              maxWidth: "300px",
              filter: `drop-shadow(0px 5px 5px ${colors.black})`,
              zIndex: 2000,
              display: "block",
              "& svg": {
                cursor: "pointer",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: theme.mode === "dark" ? colors.gray : colors.secondaryColor,
                zIndex: 9,
                padding: "3px 5px 1px 7px",
                clipPath: `polygon(
                  0% 0px,
                  0px 0%,
                  0px 0%,
                  100% 0px,
                  100% calc(100% - 20px),
                  calc(100% - 20px) 100%,
                  0px 100%
                )`,
                "& svg": {
                  cursor: "pointer",
                },
              }}
            >
              <FilterHeader>
                <H3 fSize={10} fweight={600}>
                  Filter Table Columns
                </H3>
                <TableFilterIcon
                  right={5}
                  top={5}
                  position="absolute"
                  color="#ffd401"
                  onClick={handleTooltip}
                />
              </FilterHeader>
              <FilterBody>
                {columns.map((column, index) => (
                  <VerticalCheckbox
                    key={index}
                    label={column.Header}
                    value={column.Header}
                    id={`custom-checkbox-${index}`}
                    checked={checkedState[index]}
                    onChange={() => handleFilterCheckbox(index)}
                  />
                ))}
              </FilterBody>
            </Box>
          </Box>
        </OutsideClickHandler>
      </Popper>
    </>
  );
};

export default TableFilter;
